<template>
  <div>
    <Tabbar  :menuIndex="3"/>
    <!-- 顶部图 -->
    <div class="solution_banner">
      <div class="solution_banner_title">
        <h2></h2>
        <h3>AI 行业解决方案</h3>
      </div>
    </div>
    <!-- 纸质文档电子化 -->
    <div id="camera" class="tvAi_warp">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>纸质文档电子化</h2>
          <!-- <p class="tvAi_top_title2">智能OCR识别能力方案</p> -->
          <p class="tvAi_top_p">
            位置信息进行比对、结构化管理等多种解决方案，信息处理效率将大幅度升级。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/dianzihua.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>
          教育、金融、办公
        </p>
        <ul class=" market_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market01.png"
              alt=""
            />
            <p>智能教育</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market02.png"
              alt=""
            />
            <p>广告植入</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market03.png"
              alt=""
            />
            <p>内容违规检测</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market04.png"
              alt=""
            />
            <p>文档结构化分析</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market05.png"
              alt=""
            />
            <p>安全播报</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 用户身份认证 -->
    <div id="tv" class="tvAi_warp tvAi_warp1">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>用户身份认证</h2>
          <p class="tvAi_top_p">
            自动识别字段信息、远程处理、降低用户成本已经变为必要，用户身份认证方案统一解决。
          </p>
        </div>
        <div class="tvAi_video">
          <img
            src="http://bu.dressplus.cn/cdn/media/reports/img/15318848250951.png"
            alt=""
          />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>办公、政务、交通</p>
        <ul class="tvAi_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv01.png"
              alt=""
            />
            <p>智能办公</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv02.png"
              alt=""
            />
            <p>商务交流</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv03.png"
              alt=""
            />
            <p>资质文件审核</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv04.png"
              alt=""
            />
            <p>征信评估</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv05.png"
              alt=""
            />
            <p>政务审批</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 道路违章检测 -->
    <div id="market" class="tvAi_warp">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>道路违章检测</h2>
          <p class="tvAi_top_p">
            实时监控，智能分析，人力的完美代替品。就是这么“优秀”。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/weizhang.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>
          安防、交通、社区
        </p>
        <ul class=" market_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market01.png"
              alt=""
            />
            <p>智慧企业园区</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market02.png"
              alt=""
            />
            <p>智慧交通</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market03.png"
              alt=""
            />
            <p>智慧安防</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market04.png"
              alt=""
            />
            <p>智慧居民社区</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 安防监控 -->
    <div id="monitoring" class="tvAi_warp tvAi_warp1">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>安防监控</h2>
          <p class="tvAi_top_p">
            更具实时性、高效性的服务已经诞生，一个通过AI完成安防监控的世界已经来临。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/jiankong.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>商场、工厂</p>
        <ul class="tvAi_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv01.png"
              alt=""
            />
            <p>智慧厂房</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv02.png"
              alt=""
            />
            <p>智能看护</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv03.png"
              alt=""
            />
            <p>智慧社区</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv04.png"
              alt=""
            />
            <p>智慧校园</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 人脸试妆 -->
    <div id="humanface" class="tvAi_warp">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>人脸试妆</h2>
          <p class="tvAi_top_p">
            无论是用来记录值得回忆的精彩瞬间，还是作为互动工具，未来的更具有交互能力的试妆将大有作为。
          </p>
        </div>
        <div class="tvAi_video">
          <img
            src="../assets/fangan/huazhuang.png"
            alt=""
          />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>
          相机、相册APP、短视频、直播
        </p>
        <ul class=" market_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market01.png"
              alt=""
            />
            <p>虚拟试妆</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market02.png"
              alt=""
            />
            <p>拍照购</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market03.png"
              alt=""
            />
            <p>动态AR相机</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market04.png"
              alt=""
            />
            <p>社交娱乐</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market05.png"
              alt=""
            />
            <p>人脸闸机</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market06.png"
              alt=""
            />
            <p>视频通话</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 智慧城市 -->
    <div id="wisdom" class="tvAi_warp tvAi_warp1">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>智慧城市</h2>
          <p class="tvAi_top_p">
            是不是还感觉，无法兼顾“看得远”“看得清”“看得广”，那你错了，LanSmart智慧城市让你一键享有。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/chengshi.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>交通、工厂、安防</p>
        <ul class="tvAi_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv01.png"
              alt=""
            />
            <p>智慧安防</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv02.png"
              alt=""
            />
            <p>智慧交通</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv03.png"
              alt=""
            />
            <p>智慧校园</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv04.png"
              alt=""
            />
            <p>智慧企业园区</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv05.png"
              alt=""
            />
            <p>智慧社区</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 智能家居 -->
    <div id="house" class="tvAi_warp">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>智能家居</h2>
          <p class="tvAi_top_p">
            远距离智能操控家电、机器人，让人机交互更加智能。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/jiaju.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>
          交通、VR/AR、视频直播
        </p>
        <ul class=" market_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market01.png"
              alt=""
            />
            <p>人机交互</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market02.png"
              alt=""
            />
            <p>智能家电</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market03.png"
              alt=""
            />
            <p>视频互动</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market04.png"
              alt=""
            />
            <p>智能车载</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/Market05.png"
              alt=""
            />
            <p>在线教育</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 互动娱乐 -->
    <div id="interaction" class="tvAi_warp tvAi_warp1">
      <div class="tvAi_top clearfix">
        <div class="tvAi_top_title">
          <h2>互动娱乐</h2>
          <p class="tvAi_top_p">
            更加丰富的体感互动，实时高效，给予无限的有趣生活体验。
          </p>
        </div>
        <div class="tvAi_video">
          <img src="../assets/fangan/yule.png" alt="" />
        </div>
      </div>
      <div class="tvAi_bottom">
        <h2>参考应用领域</h2>
        <p>短视频、教育、商业</p>
        <ul class="tvAi_bottom_list clearfix">
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv01.png"
              alt=""
            />
            <p>体育健身</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv02.png"
              alt=""
            />
            <p>社交互动</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv03.png"
              alt=""
            />
            <p>智慧门店</p>
          </li>
          <li>
            <img
              src="http://bu.dressplus.cn/web/static/image/tv04.png"
              alt=""
            />
            <p>无人零售货架</p>
          </li>
        </ul>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Tabbar from "@/components/Nav/Nav.vue";
import Foot from "@/components/foot/Foot.vue";
import "element-ui/lib/theme-chalk/display.css";
export default {
  components: {
    Tabbar,
    Foot,
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .solution_banner {
    background: url(http://bu.dressplus.cn/cdn/media/reports/img/15338968321711.jpeg)
      50% no-repeat;
    height: 520px;
    position: relative;
  }
  .solution_banner_title > h3 {
    font-size: 48px;
    color: #fff;
  }
  .solution_warp {
    position: relative;
    margin-top: 76px;
  }
  .solution_banner_title {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
  }
  .tvAi_top {
    width: 70%;
    margin: 0 auto;
    padding: 100px 0 90px;
  }
  .tvAi_top_title {
    width: 50%;
    float: left;
    padding-top: 6%;
  }
  .tvAi_top_title > h2 {
    font-size: 43px;
    color: #00a6ff;
  }
  .tvAi_top_title2 {
    font-size: 22px;
    color: #535353;
    margin: 30px 0 60px;
  }
  .tvAi_top_p {
    line-height: 35px;
    font-size: 17px;
    color: #999;
    width: 70%;
    margin-top: 40px;
    margin-left: 80px;
    text-align: left;
  }
  .tvAi_video > img {
    vertical-align: middle;
    width: 100%;
  }
  .tvAi_bottom > h2 {
    color: #333;
    font-size: 22px;
    padding: 2px 0 30px;
  }
  .tvAi_bottom > p {
    color: #999;
    font-size: 17px;
  }
  .market_bottom_list li {
    float: left;
    width: 16.66%;
  }
  .market_bottom_list p {
    font-size: 18px;
    color: #666;
    margin-bottom: 60px;
  }
  .market_bottom_list img {
    min-width: 70px;
    width: 30%;
    margin: 50px 0 30px;
  }
  .tvAi_warp1 {
    background: #f2f2f2;
  }
  .tvAi_bottom_list > li {
    float: left;
    width: 20%;
  }
  .tvAi_bottom_list img {
    min-width: 70px;
    width: 30%;
    margin: 50px 0 30px;
  }
  .tvAi_bottom_list p {
    font-size: 18px;
    color: #666;
    margin-bottom: 60px;
  }
  .video_warp {
    width: 58px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -29px;
    margin-left: -29px;
  }
  .tvAi_video {
    float: right;
    width: 50%;
    position: relative;
  }
  .tvAi_bottom {
    width: 70%;
    margin: 0 auto;
    text-align: center;
  }
}

@media screen and (max-width: 767px) {
  .solution_banner {
    background: url(http://bu.dressplus.cn/web/static/image/solution_bj1.jpg)
      50% no-repeat;
    height: 12.5rem;
    position: relative;
    background-size: 100% 100%;
  }
  .solution_banner_title {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 52%;
  }
  .solution_banner_title > h3 {
    font-size: 1.51rem;
    font-weight: 600;
    color: #333;
    margin-top: 0.3rem;
  }
  .tvAi_top {
    width: 85%;
    margin: 0 auto;
    padding: 1rem 0;
  }
  .tvAi_top_title > h2 {
    color: #00a6ff;
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
  }
  .tvAi_top_title2 {
    font-size: 0.37rem;
    color: #333;
    margin: 0.4rem 0 0.6rem;
  }
  .tvAi_top_p {
    line-height: 1.52rem;
    font-size: 0.3rem;
    color: #666;
  }
  .tvAi_video > img {
    vertical-align: middle;
    width: 100%;
  }
  .tvAi_video {
    position: relative;
    margin-top: 0.6rem;
  }
  .tvAi_bottom {
    width: 90%;
    margin: 0 auto;
    text-align: center;
  }
  .tvAi_bottom > h2 {
    color: #333;
    font-size: 0.37rem;
  }
  .tvAi_bottom > p {
    color: #666;
    font-size: 0.29rem;
    line-height: 1.5rem;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
  }
  .market_bottom_list li {
    float: left;
    width: 50%;
  }
  .market_bottom_list img {
    min-width: 1rem;
    width: 30%;
    margin: 0.5rem 0 0.2rem;
  }
  .market_bottom_list p {
    font-size: 0.29rem;
    color: #666;
    margin-bottom: 0.5rem;
  }
  .tvAi_warp1 {
    background: #f2f2f2;
  }
  .tvAi_bottom_list > li {
    float: left;
    width: 50%;
  }
  .tvAi_bottom_list img {
    min-width: 1rem;
    width: 30%;
    margin: 0.5rem 0 0.2rem;
  }
  .tvAi_bottom_list p {
    font-size: 0.29rem;
    color: #666;
    margin-bottom: 0.5rem;
  }
}

.clearfix:after,
.clearfix:before {
  display: table;
  content: " ";
}
.clearfix:after {
  clear: both;
}
.clearfix:after,
.clearfix:before {
  display: table;
  content: " ";
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
a {
  color: #fff;
  text-decoration: none;
  /* -webkit-backface-visibility: hidden; */
}
ul {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}
li {
  list-style: none;
}
</style>
